import { ThemeConfig } from 'antd';

// Corporate theme configuration
export const corporateTheme: ThemeConfig = {
  token: {
    // Primary Colors - Corporate Blue
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    
    // Background Colors
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#fafafa',
    colorBgLayout: '#F6F7FB',
    
    // Text Colors
    colorText: '#262626',
    colorTextSecondary: '#8c8c8c',
    colorTextTertiary: '#bfbfbf',
    colorTextQuaternary: '#f0f0f0',
    
    // Border Colors
    colorBorder: '#d9d9d9',
    colorBorderSecondary: '#f0f0f0',
    
    // Font - Inter / SF Pro style for modern SaaS
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    fontSizeLG: 16,
    fontSizeSM: 12,
    fontSizeXL: 20,
    
    // Border Radius - Premium rounded corners
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    borderRadiusXS: 4,
    
    // Spacing
    sizeStep: 4,
    sizeUnit: 4,
    
    // Control Height
    controlHeight: 32,
    controlHeightLG: 40,
    controlHeightSM: 24,
    
    // Line Height
    lineHeight: 1.5715,
    lineHeightLG: 1.5,
    lineHeightSM: 1.66,
    
    // Box Shadow
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    boxShadowSecondary: '0 4px 12px rgba(0, 0, 0, 0.15)',
    
    // Motion
    motionDurationFast: '0.1s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
  },
  components: {
    // Layout
    Layout: {
      bodyBg: '#F6F7FB',
      headerBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
      siderBg: '#001529',
      triggerBg: '#002140',
      triggerColor: '#ffffff',
    },
    
    // Menu
    Menu: {
      itemBg: 'transparent',
      itemHoverBg: 'rgba(255, 255, 255, 0.08)',
      itemSelectedBg: '#1890ff',
      itemSelectedColor: '#ffffff',
      itemActiveBg: 'rgba(24, 144, 255, 0.1)',
      itemHoverColor: '#ffffff',
      subMenuItemBg: 'transparent',
      darkItemBg: 'transparent',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
      darkItemSelectedBg: '#1890ff',
      darkItemSelectedColor: '#ffffff',
      darkSubMenuItemBg: 'transparent',
    },
    
    // Button
    Button: {
      primaryShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
      defaultShadow: '0 2px 0 rgba(0, 0, 0, 0.015)',
      fontWeight: 500,
      borderRadius: 6,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,
    },
    
    // Input
    Input: {
      activeBorderColor: '#1890ff',
      hoverBorderColor: '#40a9ff',
      borderRadius: 6,
      paddingInline: 12,
      paddingBlock: 8,
    },
    
    // Card - Enterprise logistics style
    Card: {
      borderRadius: 12,
      paddingLG: 20,
      headerBg: 'transparent',
      actionsBg: '#ffffff',
    },
    
    // Table
    Table: {
      borderRadius: 8,
      headerBg: '#fafafa',
      headerColor: '#262626',
      rowHoverBg: '#f5f5f5',
    },
    
    // Form
    Form: {
      labelColor: '#262626',
      labelFontSize: 14,
      itemMarginBottom: 24,
    },
    
    // Modal - Modern compact
    Modal: {
      borderRadius: 12,
      headerBg: '#ffffff',
      titleFontSize: 18,
      titleLineHeight: 1.5,
    },
    
    // Drawer
    Drawer: {
      borderRadius: 8,
    },
    
    // Select
    Select: {
      borderRadius: 6,
      optionSelectedBg: '#e6f7ff',
    },
    
    // Tabs
    Tabs: {
      itemActiveColor: '#1890ff',
      itemHoverColor: '#40a9ff',
      itemSelectedColor: '#1890ff',
      inkBarColor: '#1890ff',
    },
    
    // Tag
    Tag: {
      borderRadius: 4,
      fontSize: 12,
    },
    
    // Typography
    Typography: {
      titleMarginBottom: '0.5em',
      titleMarginTop: '1.2em',
    },
  },
};

